import React from 'react';
import { Badge } from '../UI';

export type SignupSite = 'worksheets' | 'readers' | null | undefined;

const LABELS = { worksheets: 'Worksheets', readers: 'No Fuss Readers' };

/** Which site the person first signed up on. Accounts are mirrored to the other site at sign up. */
export const SignupSiteBadge: React.FC<{ site: SignupSite }> = ({ site }) =>
  site ? <Badge tone={site === 'readers' ? 'school' : 'paid'}>{LABELS[site]}</Badge> : <span className="muted">Not recorded</span>;

/** Badge plus a quiet note when the person also has an account on the other site. */
export const SignupSiteCell: React.FC<{ site: SignupSite; alsoOnOther?: boolean; other: 'worksheets' | 'readers' }> = ({ site, alsoOnOther, other }) => (
  <div style={{ display: 'grid', gap: '0.3rem', justifyItems: 'start' }}>
    <SignupSiteBadge site={site} />
    {alsoOnOther && site !== other && <span className="muted" style={{ fontSize: '1.2rem' }}>Also on {other === 'readers' ? 'Readers' : 'worksheets'}</span>}
  </div>
);
